<div class="container">
  <p class="title">{{'symptomAssessment.title_symptoms_step' | translate}}</p>
  <div class="filter-container">
    <ds-search [control]="searchValues.commonInput.control" [placeholder]="'symptomAssessment.search' | translate"></ds-search>
  </div>
  <form [formGroup]="symptomsForm">
    <nz-form-item *ngFor="let symptom of filteredSymptoms">
      <nz-form-control>
        <label nz-checkbox [formControlName]="symptom.label">{{ symptom.label }}</label>
      </nz-form-control>
    </nz-form-item>
  </form>
</div>